import { createStore } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import { responsiveStoreEnhancer } from 'redux-responsive';
import reducer from './reducer';

const store = createStore(reducer, composeWithDevTools(responsiveStoreEnhancer));

export default store;
